import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BrowsePage from './pages/BrowsePage';
import DepartmentPage from './pages/DepartmentPage';
import ResourcePage from './pages/ResourcePage';
import AdminPage from './pages/AdminPage';
import NotFoundPage from './pages/NotFoundPage';
import './index.css';

function App() {
  const ADMIN_PATH = process.env.REACT_APP_ADMIN_PATH || 'x9k2m7p4';
  const ADMIN_SECRET = process.env.REACT_APP_ADMIN_SECRET || '8f3e2a1b';
  
  const urlParams = new URLSearchParams(window.location.search);
  const hasValidSecret = urlParams.get('secret') === ADMIN_SECRET;
  
  const isAdminRoute = window.location.pathname === `/${ADMIN_PATH}` && hasValidSecret;

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/browse" element={<BrowsePage />} />
        <Route path="/department/:deptName" element={<DepartmentPage />} />
        <Route path="/resource/:id" element={<ResourcePage />} />
        {isAdminRoute && <Route path={`/${ADMIN_PATH}`} element={<AdminPage />} />}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
}

export default App;